import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { TipologiaDocumentoDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class TipologiaDocumentoApiClient extends BaseCRUDApiClient<TipologiaDocumentoDto> {
  baseUrl = this.config.apiEndpoint + '/tipologia-documento';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
